module.exports = __webpack_public_path__ + "assets/img/parent_code_icon.svg";